import {Component, EventEmitter, Input, Output} from "@angular/core";
import {DateLevelEnum} from "./date-level-enum";

@Component({
  selector: 'yo-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent {

  @Input() value: Date;
  @Input() selectLevel: DateLevelEnum;

  @Output() onValueChange: EventEmitter<Date> = new EventEmitter;

  getSelectedLevel = () => {
    switch (this.selectLevel) {
      case DateLevelEnum.YEAR:
        return "decade";
      case DateLevelEnum.MONTH:
        return "year";
      case DateLevelEnum.DAY:
        return "month";
    }
  }

  getDisplayFormat = () => {
    switch (this.selectLevel) {
      case DateLevelEnum.YEAR:
        return "yyyy";
      case DateLevelEnum.MONTH:
        return "MM/yyyy";
      case DateLevelEnum.DAY:
        return "DD/MM/yyyy";
    }
  };

  onDateSelected = ($event) => {
    this.onValueChange.emit($event.value);
  }
}
